module.exports = __webpack_public_path__ + "assets/img/13-s.0d458e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/13-s.jpg
// module id = gqAm
// module chunks = 0